import { create } from 'zustand';

/**
 * Creations management store using Zustand
 * Tracks all images generated by the user
 */
const useCreations = create((set) => ({
  // Initial state - array of image objects with URLs and metadata
  creations: [],
  
  // Add a new creation to the list
  addCreation: (imageUrl, prompt) => {
    const newCreation = {
      id: Date.now().toString(),
      imageUrl,
      prompt,
      createdAt: new Date().toISOString(),
    };
    
    set((state) => ({
      creations: [newCreation, ...state.creations]
    }));
    
    return newCreation;
  },
  
  // Clear all creations (mainly for logout or testing)
  clearCreations: () => {
    set({ creations: [] });
  },
  
  // Remove a specific creation by ID
  removeCreation: (creationId) => {
    set((state) => ({
      creations: state.creations.filter(creation => creation.id !== creationId)
    }));
  }
}));

export default useCreations; 